export const Layout = {
    MOBILE: 'Mobile',
    TABLET: 'Tablet',
    DESKTOP: 'Desktop'
};



// WEBPACK FOOTER //
// ./resources/modules/shared/constants/index.ts